import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
	Tooltip,
	Typography,
} from "@material-ui/core";

// Dica de ajuda com título + texto. Cor, raio e seta vêm do tema (MuiTooltip);
// aqui só o que muda por ter mais de uma linha.
const useStyles = makeStyles(() => ({
	tooltip: {
		maxWidth: 320,
		padding: "10px 12px",
		textAlign: "left",
	},
	title: {
		fontSize: 12.5,
		fontWeight: 600,
		lineHeight: 1.4,
	},
	content: {
		marginTop: 4,
		fontSize: 12,
		fontWeight: 400,
		lineHeight: 1.5,
		opacity: 0.86,
	},
}));

const ToolTip = ({ title, content, children }) => {
	const classes = useStyles();

	return (
		<Tooltip
			arrow
			classes={{
				tooltip: classes.tooltip,
			}}
			title={
				<React.Fragment>
					<Typography component="div" color="inherit" className={classes.title}>
						{title}
					</Typography>
					{content && (
						<Typography component="div" color="inherit" className={classes.content}>
							{content}
						</Typography>
					)}
				</React.Fragment>
			}
		>
			{children}
		</Tooltip>
	);
};

export default ToolTip
